import { calculateStaffRanking as getTableData } from "../calculateStaffRanking";
import { getBranchInfobyId } from "../multipleBranch/getActiveBranchId";
export function tabulateStaffRankingPDF(data) {
  // now we transform this d1 into format like [43,5,656] which will be fed to pdf table.
  if (data == null) return null;
  let output = [];

  data.forEach((bData) => {
    let branchName = getBranchInfobyId(bData.bId).name;
    const d2 = getTableData(bData.data[0].datasets);
    let superStaffArr = [];
    d2.forEach((staffObj) => {
      let staffArr = [];
      staffArr.push(staffObj.name);
      staffArr.push(staffObj.score);
      staffArr.push(` ${staffObj.avgScore}(${staffObj.frequency})`);

      superStaffArr.push(staffArr);
    });

    let obj = {
      branchName,
      data: [...superStaffArr],
    };
    output.push(obj);
  });
  console.log(output);
  return output;
}

export function tabulateStaffDataPDF(data) {
  if (data == null) return null;

  let output = [];
  data.forEach((item) => {
    console.log(item.tableData);
    let obj = { data: [] };
    obj.branchName = getBranchInfobyId(item.bId).name;

    let allTableRows = [];
    item.tableData.forEach((row) => {
      let tableRow = [
        row.name,
        row.score,
        `${row.avgScore} (${row.frequency})`,
      ];
      allTableRows.push(tableRow);
    });

    obj.data = allTableRows;

    output.push(obj);
  });
  console.log(output);

  return output;
}
